import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import Header from '../template/header/Header.jsx';
import SideBar from '../template/sidebar/SideBar.jsx';
import MenuItem from '../template/sidebar/MenuItem.jsx';
import MenuTree from '../template/sidebar/MenuTree.jsx';
import ContentWrapper from '../componentes/ContentWrapper.jsx';
import Footer from '../template/footer/Footer.jsx';
import Cookies from '../../lib_react_frontend/utils/Cookies.jsx';
import GenericApi from '../../lib_react_frontend/utils/GenericApi';
import ApiceValidadorSessao from '../../lib_react_frontend/componentes/ApiceValidadorSessao.jsx';
import Input from '../componentes/Input.jsx';
import ModalAlterarSenha from './ModalAlterarSenha';
/**
 * Tela da aplicação.
 */
class App extends React.Component {

  async componentWillMount() {
    document.body.className = (global.app.options.skin ? global.app.options.skin :
      ' skin-blue-light ') + ' sidebar-mini ' +
      (global.app.options.iniciarAberto ? '' : 'sidebar-collapse');
    const ret = await GenericApi.validarAuth();
    if (ret.status) {
      this.props.dispatch({
        type: 'on_login',
        usuario: ret.dados.usuario,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mudarSenha != this.props.mudarSenha) {
      this.modalSenha.getWrappedInstance().show();
    }
  }

  onChangeFiltro(e) {
    this.props.dispatch({
      type: 'on_filtrar_itens',
      valor: e.target.value,
    });
  }

  getConteudo() {
    const createItem = (rota, label, icone, render, children, notBotao) => ({
      rota, label, icone, render, children, notBotao,
    });
    return global.app.menus(this.props.redux, createItem).filter(x => x);
  }

  /**
   * Realiza o logout da aplicação, isso apaga o token de autenticação
   * e retorna à pagina de login.
   */
  realizarLogout() { 
    if (this.props.socket) {
      this.props.socket.logoutUsuario();
    }

    Cookies.erase(global.app.cookie);
    this.props.history.push('/');
  }

  renderMenuItens() {
    return this.getConteudo().map(x => (
      x.children ? (
        <MenuTree key={x.rota} label={x.label} icon={x.icone}>
          {x.children.map(q => (
            <MenuItem key={q.rota} path={'/app/' + x.rota + '/' + q.rota}
              label={q.label} icon={q.icone} />
          ))}
        </MenuTree>
      ) : (
          x.rota && !x.notBotao ?
            <MenuItem key={x.rota} path={'/app/' + x.rota} label={x.label} icon={x.icone} /> : null
        )
    ));
  }

  renderRoutes() {
    const conteudos = this.getConteudo();
    const routes = [];
    for (const conteudo of conteudos) {
      if (conteudo.children) {

        for (const child of conteudo.children) {
          routes.push(
            <Route exact key={child.rota}
              path={'/app/' + conteudo.rota + '/' + child.rota}
              component={child.render || ContentWrapper} />
          );
        }

      } else {
        routes.push(
          <Route exact={!conteudo.notBotao}
            key={conteudo.rota}
            path={'/app/' + conteudo.rota}
            component={conteudo.render || ContentWrapper} />
        );
      }
    }
    return routes;
  }

  render() {
    return (
      <ApiceValidadorSessao history={this.props.history}>
        <Header tituloGrande={global.app.nomeAplicacao}
          dados_empresa={this.props.dados_empresa ? this.props.dados_empresa : ''}
          tituloPequeno={<i className={'fa ' + global.app.icone} />}
          icon={global.app.icone}
          usuario={{}}
          rota={global.app.options.landingPage ?
            ('/' + global.app.options.landingPage) :
            '/app'}
          onLogout={this.realizarLogout.bind(this)} />

        <SideBar>
          {/* {global.app.options.usarFiltro && (
            <Input value={this.props.filtroItens}
              placeholder='Pesqdddduisar'
              onChange={this.onChangeFiltro.bind(this)} />
          )} */}
          {this.renderMenuItens()}
        </SideBar>

        <Switch>
          {this.renderRoutes()}
          <Route component={ContentWrapper} />
        </Switch>

        <ModalAlterarSenha ref={e => this.modalSenha = e} />
        <Footer titulo="Ápice Sistemas" link="http://apicesistemas.com.br" />
      </ApiceValidadorSessao>
    );
  }

}

export default connect((state) => ({
  usuario: state.usuario,
  redux: state,
  mudarSenha: state.mudarSenha,
  dados_empresa: state.dados_empresa,
  socket: state.socket,
}), (dispatch) => ({
  dispatch,
}))(App);




// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/App.jsx